import axios from "axios";
import {url_local} from '../url'
//import state from "../../store";
import state from '../../store/index'


export function SubirConductor(form) {
    //console.log(state.state.currentUser.access_token);
    const config = {
        headers : {
            'Content-Type' : 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Authorization: "Bearer " +state.state.currentUser.access_token
        }
    }

    return new Promise((res, rej) => {
        axios.post(`${url_local}conductor`, form, config).then(response => {
            res(response.data);
        })
        .catch(err => {
            rej("error al subir el conductor: " + err);
        });
    });
    }


    export function EditarConductor(form, id) {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.post(`${url_local}edit_conductor/${id}`, form, config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al editar el conductor: " + err);
            });
        });
        }


        export function DeleteConductor(id) {
            //console.log(state.state.currentUser.access_token);
            const config = {
                headers : {
                    'Content-Type' : 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    Authorization: "Bearer " +state.state.currentUser.access_token
                }
            }
        
            return new Promise((res, rej) => {
                axios.delete(`${url_local}conductor/${id}`, config).then(response => {
                    res(response.data);
                })
                .catch(err => {
                    rej("error al borrar el conductor: " + err);
                });
            });
            }





    export function GetConductor() {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.get(`${url_local}conductor`, config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al obtener el conductor: " + err);
            });
        });
      }

      export function GetConductor_select() {
        //console.log(state.state.currentUser.access_token);
        const config = {
            headers : {
                'Content-Type' : 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                Authorization: "Bearer " +state.state.currentUser.access_token
            }
        }
    
        return new Promise((res, rej) => {
            axios.get(`${url_local}conductor_select`, config).then(response => {
                res(response.data);
            })
            .catch(err => {
                rej("error al obtener el conductor: " + err);
            });
        });
      }

